export default __webpack_public_path__ + "static/media/kyc.6a1e1289.svg";